// 쿠키 관리 유틸리티 함수들

export interface SavedLoginInfo {
  centerId: string;
  loginId: string;
}

// 쿠키 설정
export const setCookie = (
  name: string,
  value: string,
  days: number = 30
): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(
    value
  )};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

// 쿠키 가져오기
export const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
};

// 쿠키 삭제
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// 로그인 정보 저장
export const saveLoginInfo = (centerId: string, loginId: string): void => {
  const loginInfo: SavedLoginInfo = { centerId, loginId };
  setCookie("savedLoginInfo", JSON.stringify(loginInfo), 30);
};

// 저장된 로그인 정보 가져오기
export const getSavedLoginInfo = (): SavedLoginInfo | null => {
  const saved = getCookie("savedLoginInfo");
  if (saved) {
    try {
      return JSON.parse(saved) as SavedLoginInfo;
    } catch (error) {
      console.error("쿠키 파싱 오류:", error);
      deleteCookie("savedLoginInfo");
    }
  }
  return null;
};

// 저장된 로그인 정보 삭제
export const clearSavedLoginInfo = (): void => {
  deleteCookie("savedLoginInfo");
};
